var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,attrs:{"role":"spinner"}},[_c('span',{staticClass:"slds-assistive-text"},[_vm._v("Loading")]),_c('div',{staticClass:"slds-spinner__dot-a"}),_c('div',{staticClass:"slds-spinner__dot-b"})])}
var staticRenderFns = []

export { render, staticRenderFns }